import dynamic from "next/dynamic";
import Image from "next/image";
import {useAmp} from "next/amp";

export const config = {amp: 'hybrid'}

declare global {
    namespace JSX {
        interface IntrinsicElements {
            [elemName: string]: any;
        }
    }
}

const ResponsiveImage = (props:any) => {
    const isAmp = useAmp();
    if (isAmp) {
        return <amp-img {...props} layout="fill"/>
    } else {
        return <Image alt={props.alt} layout="fill" {...props} objectFit={'cover'} priority={false} loading={"lazy"}/>
    }
}

const AdvertisementComponents = {
    // It also works with dynamically-imported components, which is especially
    // useful for conditionally loading components for certain routes.
    // See the notes in README.md for more details.
    img: ResponsiveImage,
    BlogPreview: dynamic(() => import('../../src/components/blog/BlogPreview')),
    SubHeroAreaText: dynamic(() => import('../../src/components/subHeroAreaText/SubHeroAreaText')),
    LandingColumnComp: dynamic(() => import('../../src/components/landing/LandingColumnComp')),
    SubHeroSuccessStory: dynamic(() => import('../../src/components/subHeroSuccessStory/SubHeroSuccessStory')),
    HowIsItWorking: dynamic(() => import('../../src/components/howIsItWorking/HowIsItWorking')),
    PropertyLines: dynamic(() => import('../../src/components/propertyLines/PropertyLines')),
    WhyPinkBlinds: dynamic(() => import('../../src/components/whyPinkBlinds/WhyPinkBlinds')),
    Security: dynamic(() => import('../../src/components/security/Security')),
    MobileApp: dynamic(() => import('../../src/components/mobileApp/MobileApp')),
    CustomerService: dynamic(() => import('../../src/components/customerService/customerService')),
}

export default AdvertisementComponents;
